













import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.kitchen.surface",
        };
    },
    computed: {
        floorKitchenArea: function(): string|null {
            const fKitchenArea = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(fKitchenArea) {
                return fKitchenArea;
            }
            return "";
        },
    },
    methods: {
        updateValue: function(floorAreaKitchen: number): void {
            if (floorAreaKitchen == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorAreaKitchen});
            }
        }
    }
});

